// this file is automatically generated by git.revision.js script
export const versions = { revision: '585689efeb' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '585689efeb';
